<template>
  <div class="box-print-serial-number"  v-if="listData" >
    <div class="box-item-serial-number" >
      <table class="print_table" style="margin: auto;">
        <tr>
          <td>
      <div style="padding-bottom: 0px; padding-top: 3px; padding-left: 0.1959cm; padding-right: 0.1959cm;position: relative; background: #fff; width: 5cm;  margin: 0; /*margin-left: 0.3cm;*/ page-break-after: always; margin-bottom: 10px;" class="board-item" :key="index" v-for="(item, index) in listData">
        <templateSerialNumber :title="title" :note="note" :hotline="hotline" :codeValue="$myConstants.getUrlChecker() + '/check-warranty-detail/' + item.serial_number" :modelCode="$myConstants.replaceAllSpace(item.product.model_code)" :serialNumber="$myConstants.replaceAllSpace(item.serial_number)" />
      </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import templateSerialNumber from './templateSerialNumberScreen'

export default {
  props: {
    listData: Array,
    title: String,
    note: String,
    hotline: String
  },
  components: {
    templateSerialNumber
  },
  created () {
    document.body.style.zoom = "100%";
  }
}
</script>

<style lang="css">
body{
  width: fit-content;
  margin: auto;
}
.print_table{
  margin: auto;
}
</style>